import Layout from "../../components/Layout/Layout";
import { Link } from 'react-router-dom';
import React, { useState, Fragment } from 'react'
import { SearchIcon, QuestionMarkCircleIcon, arrowUpTray } from '@heroicons/react/solid';
import { PlusCircleIcon, DotsHorizontalIcon } from "@heroicons/react/outline";
import UserServices from '../../services/UserServices';
import { useEffect } from 'react';
import Paginate from '../../utils/Paginate';
import { Menu, Transition } from '@headlessui/react'
import fire from './../../utils/Toastr';
import PreOnboardServices from "../../services/PreObnoard";
import FileUploadComponent from "../../components/UploadFile";
import FileUploadAndDownloadComponent from "../../components/FileUploadAndDownloadComponent";
import Resend from "../../components/Modals/preonboard/resend";

export default function PreOnboarding(){
    
  const [user, setUsers] = useState([]);
  const [search, setSearch] = useState("")
  const [pageIndex, setPageIndex] = useState(1);
  const [prevPage, setPrev] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPage, setPage] = useState(0);
  const [nextPage, setNextPage] = useState(false);
  const [pageLength, setPageLength] = useState("");
  const [adminType, setAdminType] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setIsLoading] = useState(false);
  const [currentAccountNumber, setCurrentAccountNumber] = useState(null);

  
  const listAllUsers = async (search) => {
    const details = await PreOnboardServices.getAllUsers(pageIndex, 10, search);
    console.log("details",[...details.data.result])
    setUsers([...details.data.result]);
    localStorage.setItem("details", JSON.stringify(details.data.result));
    setPageLength([...details.data.result].length);
    setPageNumber(details.data.totalCount);
    setPageIndex(details.data.pageIndex);
    setPrev(details.data.hasPreviousPage);
    setPage(details.data.totalPages);
    setNextPage(details.data.hasNextPage);
  }
  const listUser = async () => {
    listAllUsers(search);
    const userDetail = sessionStorage.getItem("user");
    const userDetails = JSON.parse(userDetail);
    setAdminType(userDetails.adminType);
  }


  const searchUser = async (text) => {
    setSearch(text);
  }
  const disactivate = async (username) => {
    const resp = await UserServices.disableUser({
      userName: username
    });
    if (resp) {
      fire("success", resp.message);
      setTimeout(() => {
        window.location.reload();
      }, 5000);
    }

  }
  const searchUsers = async () => {
    listAllUsers(search);
  }

  const handleResendMail = (accountNumber) => {
    setCurrentAccountNumber(accountNumber);
    setIsModalOpen(true);
  };

  const confirmResendMail = async () => {
    setIsLoading(true);
    try {
      const response = await PreOnboardServices.resendEmails({
        accountNumber: currentAccountNumber,
      });
      setIsModalOpen(false);
      setIsLoading(false);
      fire("success", response.message);
    } catch (error) {
      fire("error", error);
    }
  };
  useEffect(() => {
    listUser();
  }, []);
  useEffect(() => {
    listUser();
  }, [pageIndex]);

    return (
        <Layout title={'PreOnboarding Users'} current={'preonboar'} pageTag="preonboarding">
           <React.Fragment>
        <main>
          <div className='max-w-7xl px-4 sm:px-6 md:px-8'>
          
              <div className="sm:flex sm:items-center">
                <div className="sm:flex-auto flex justify-between">
                  <div className='flex'>
                    <div className="mt-1 relative rounded-md shadow-sm">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                      </div>
                      <input
                        type="text"
                        name="user"
                        id="user"
                        onChange={(e) => searchUser(e.target.value)}
                        className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                        placeholder="Search users"
                      />
                      <div className=" absolute inset-y-0 right-0 flex items-center pr-3">
                        <div className='tooltip'>
                          <QuestionMarkCircleIcon className="w-4 mr-1.5 text-gray-400" />
                          <span className="tooltiptext"> <p>Search by first name,surname, role name , email address and username</p></span>
                        </div>
                      </div>
                    </div>
                    <div className='mt-1 ml-4'>
                      <button
                        onClick={searchUsers}
                        className='hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto'>Search</button>
                    </div>
                  </div>
                    <FileUploadAndDownloadComponent details={user}/>
                </div>

              </div>
              {user.length === 0 ? (
                <div className="mt-8"> No data available for these dates to show. </div>
              ) :
                <>
                  <div className="mt-8 flex ">
                    <div className="-my-2 -mx-4 overflow-x-auto ">
                      <div className="inline-block min-w-full py-2 align-middle mb-20 ">
                        <div className="relative ring-1 ring-black ring-opacity-5 md:rounded-lg">
                          <table className="min-w-full table-fixed divide-y divide-gray-300">
                            <thead>
                              <tr>

                                <th scope="col" className="min-w-[9rem] py-3.5 pl-5 pr-3 italic font-normal text-left text-sm text-gray-400">
                                FirstName
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                Surname
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                Email Address
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                Phone Number
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                  Status
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                Account Number
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                  Bvn
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                  NIN
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                  Date of birth
                                </th>
                               
                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                  <span className="sr-only">View</span>
                                </th>
                              </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200 bg-white">
                              {user.map((person, i) => (
                                <tr key={i} className="bg-gray-50">
                                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.firstName}</td>
                                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.surname}</td>
                                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.emailAddress}</td>
                                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.phoneNumber}</td>
                                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.userPreOnboardingStatus}</td>
                                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.accountNumber}</td>
                                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person?.bvn}</td>
                                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.nationalIdentificationNumber}</td>
                                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                    {new Date(person.dateOfBirth).toLocaleDateString('en-US', {
                                      month: 'short',
                                      day: 'numeric',
                                      year: 'numeric'
                                    })}
                                  </td>
                                  <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                    <Menu as="div" className="ml-3  flex-shrink-0">
                                      <div>
                                        <Menu.Button className="  flex text-sm text-white">
                                          <span className="sr-only">Open user menu</span>
                                          <DotsHorizontalIcon className='w-8 text-gray-400' />
                                        </Menu.Button>
                                      </div>
                                      <Transition
                                        as={Fragment}
                                        enter="transition ease-out duration-100"
                                        enterFrom="transform opacity-0 scale-95"
                                        enterTo="transform opacity-100 scale-100"
                                        leave="transition ease-in duration-75"
                                        leaveFrom="transform opacity-100 scale-100"
                                        leaveTo="transform opacity-0 scale-95"
                                      >
                                        <Menu.Items className="origin-top-right absolute right-6 mt-2 w-40 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                                        <Link
                                          to={`/preonboard/view/?username=${person.accountNumber}`}
                                          className="block py-2 px-5 text-sm text-gray-700 text-left"
                                        >
                                          View User
                                        </Link>
                                        <button
                                          type="button"
                                          onClick={() =>
                                            handleResendMail(
                                              person.accountNumber
                                            )
                                          }
                                          className="block py-2 px-5 text-sm text-gray-700 text-left"
                                        >
                                          Resend Mail
                                        </button>
                                        {/* <button
                                            type='button'
                                            onClick={() => disactivate(person.userName)}
                                            className="block py-2 px-5 text-sm text-gray-700 text-left">
                                            Disable User
                                          </button> */}
                                        {/* {adminType.toLowerCase() === "checker" &&
                                            <>
                                              <Link to={`/update/user?id=${person.userName}`} className="block py-2 px-5 text-sm text-gray-700 text-left">
                                                Edit User
                                              </Link>
                                            </>
                                          } */}
                                      </Menu.Items>
                                      </Transition>
                                    </Menu>

                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Paginate
                                    nextPage={nextPage}
                                    pageIndex={pageIndex}
                                    totalCount={pageNumber}
                                    totalPages={totalPage}
                                    prevPage={prevPage}
                                    setPageIndex={setPageIndex}
                                />
                </>}

            </div>
        </main>
        <Resend
        textField="to resend the activation email"
        action={confirmResendMail}
        open={isModalOpen}
        setOpen={setIsModalOpen}
        loading={loading}
      />

      </React.Fragment>
        </Layout>
    )
}